import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import TransporterPage from "../masters/transporter/transporterlist";
// import DockMasterPage from "../masters/vehicletype/vehiclelist";

export default function SlideWidgets() {
 const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
const delays = [5000, 5000, 1000]; // ms per slide

  useEffect(() => {
    const timeout = setTimeout(() => {
      const nextSlide = (currentSlide + 1) % delays.length;
      sliderRef.current?.slickGoTo(nextSlide);
    }, delays[currentSlide]);

    return () => clearTimeout(timeout);
  }, [currentSlide]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: false, // Manual autoplay
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index) => setCurrentSlide(index),
  };

  return (
    <Slider ref={sliderRef} {...settings}>
      {/* <TransporterPage/>
      <DockMasterPage/> */}
      <div style={{height:"calc(100vh - 120px)"}}>
      <iframe
      src="https://app.mawalog.com"
      style={{
    width: "100%",
    height: "calc(100vh - 120px)", // 100% of viewport height
    border: "none",
  }}
    ></iframe>
    </div>
    </Slider>
  );
}